import { default as teaserMessages } from 'govbr.frontend.policy/messages/teaser';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Target: {
    id: 'Target',
    defaultMessage: 'Target',
  },
  imageOverride: {
    id: 'Image override',
    defaultMessage: 'Image override',
  },
  openLinkInNewTab: {
    id: 'Open in a new tab',
    defaultMessage: 'Open in a new tab',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  head_title: {
    id: 'head_title',
    defaultMessage: 'Head title',
  },
  teaser: {
    id: 'Teaser',
    defaultMessage: 'Teaser',
  },
  align: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },

  // novos
  overwrite: {
    id: 'Customize teaser content',
    defaultMessage: 'Customize teaser content',
  },
  overwriteDescription: {
    id: 'The block will update when the target is edited. Check this option to keep the teaser fixed and customize its content.',
    defaultMessage:
      'The block will update when the target is edited. Check this option to keep the teaser fixed and customize its content.',
    // O bloco será atualizado quando o alvo for editado. Marque esta opção para manter o teaser fixo e personalizar seu conteúdo.
  },
  // overwriteDescription: {
  //   id: 'Check this box to customize the title, description, or image of the target content item for this teaser.
  // Leave it unchecked to show updates to the target content item if it is edited later.',
  //   defaultMessage:
  //     'Check this box to customize the title, description, or image of the target content item for this teaser. Leave it unchecked to show updates to the target content item if it is edited later.',
  // },
  subtitleDescription: {
    id: 'If the subtitle is empty, it will be replaced by the category.',
    defaultMessage:
      'If the subtitle is empty, it will be replaced by the category.',

    //  Se o subtítulo estiver vazio, ele será substituído pela categoria.
  },
  subtitle: {
    id: 'Subtitle',
    defaultMessage: 'Subtitle',
  },
  aspectRatioMobile: {
    id: 'Aspect ratio - Mobile',
    defaultMessage: 'Aspect ratio - Mobile',
  },
  aspectRatioDesktop: {
    id: 'Aspect ratio - Desktop',
    defaultMessage: 'Aspect ratio - Desktop',
  },
  hideDescription: {
    id: 'Hide Description',
    defaultMessage: 'Hide Description',
  },
  hideImage: {
    id: 'Hide Image',
    defaultMessage: 'Hide Image',
  },
  hideSubtitleCategory: {
    id: 'Hide Subtitle/Category',
    defaultMessage: 'Hide Subtitle/Category',
  },
});

export const TeaserSchema = ({ data, intl }) => {
  // O primeiro valor representa o percentual da largura da imagem
  // a ser aplicado à altura
  const aspectRatioChoices = [
    ['100%', '1/1'],
    ['66.6666%', '3/2'],
    ['75%', '4/3'],
    ['56.25%', '16/9'],
    ['50%', '2/1'],
    ['33.3333%', '3/1'],
    ['125%', '4/5'],
    ['120%', '5/6'],
    ['150%', '3/4'],
    ['177.78%', '9/16'],
  ];

  const schema = {
    title: intl.formatMessage(messages.teaser),
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(teaserMessages.Default),
        fields: [
          'href',
          'overwrite',
          ...(data?.overwrite
            ? ['subtitle', 'title', 'description', 'preview_image', 'image_alt']
            : []),
        ],
      },
      {
        id: 'image',
        title: intl.formatMessage(teaserMessages.Image),
        fields: [
          'aspectRatioMode',
          ...(data?.aspectRatioMode !== 'free'
            ? [
                'aspectRatioHelp',
                'aspectRatioDesktop',
                'aspectRatioTablet',
                'aspectRatioMobile',
              ]
            : []),
          'horizontalAlign',
          'verticalAlign',
          'imageBackground',
        ],
      },
      {
        id: 'fields',
        title: intl.formatMessage(teaserMessages.Fields),
        fields: ['hideImage', 'hideDescription', 'hideSubtitle'],
      },
    ],

    properties: {
      href: {
        title: intl.formatMessage(messages.Target),
        description: intl.formatMessage(teaserMessages.hrefDescription),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: [
          'Title',
          'head_title',
          'Description',
          'category_title',
          'dados_noticia',
          'subtitle',
          'hasPreviewImage',
          'image_field',
          'image_scales',
          '@type',
          'review_state',
          'alt',
        ],
        allowExternals: true,
      },
      overwrite: {
        title: intl.formatMessage(teaserMessages.overwrite),
        description: intl.formatMessage(teaserMessages.overwriteDescription),
        // description: (
        //   <div>
        //     <div>{intl.formatMessage(messages.overwriteDescription)}</div>
        //     <div>{intl.formatMessage(messages.subtitleDescription)}</div>
        //   </div>
        // ),

        type: 'boolean',
        default: false,
      },
      title: {
        title: intl.formatMessage(messages.title),
      },
      subtitle: {
        title: intl.formatMessage(messages.subtitle),
      },
      description: {
        title: intl.formatMessage(messages.description),
        widget: 'textarea',
      },
      preview_image: {
        title: intl.formatMessage(messages.imageOverride),
        widget: 'object_browser',
        mode: 'image',
        allowExternals: true,
        selectedItemAttrs: [
          'image_field',
          'image_scales',
          'image_caption',
          'alt',
        ],
      },
      image_alt: {
        title: intl.formatMessage(teaserMessages.imageAlt),
        description: intl.formatMessage(teaserMessages.imageAltDescription),
      },
      openLinkInNewTab: {
        title: intl.formatMessage(messages.openLinkInNewTab),
        type: 'boolean',
      },
      aspectRatioMode: {
        title: intl.formatMessage(teaserMessages.aspectRatioMode),
        description: intl.formatMessage(teaserMessages.aspectRatioModeHelp),
        type: 'string',
        widget: 'radio_group',
        default: 'fixed',
        choices: [
          ['fixed', intl.formatMessage(teaserMessages.aspectRatioFixed)],
          ['free', intl.formatMessage(teaserMessages.aspectRatioFree)],
        ],
      },
      aspectRatioHelp: {
        widget: 'help_message_widget',
        body: intl.formatMessage(teaserMessages.aspectRatioHelp),
      },
      aspectRatioDesktop: {
        title: intl.formatMessage(teaserMessages.aspectRatioDesktop),
        required: true,
        noValueOption: true,
        default: '56.25%',
        type: 'string',
        factory: 'Choice',
        choices: aspectRatioChoices,
      },
      aspectRatioTablet: {
        title: intl.formatMessage(teaserMessages.aspectRatioTablet),
        required: true,
        noValueOption: true,
        default: '75%',
        type: 'string',
        factory: 'Choice',
        choices: aspectRatioChoices,
      },
      aspectRatioMobile: {
        title: intl.formatMessage(teaserMessages.aspectRatioMobile),
        required: true,
        noValueOption: true,
        default: '66.6666%',
        type: 'string',
        factory: 'Choice',
        choices: aspectRatioChoices,
      },
      imageBackground: {
        title: intl.formatMessage(teaserMessages.imageAsBackground),
        description: intl.formatMessage(
          teaserMessages.imageAsBackgroundDescription,
        ),
        type: 'boolean',
        default: false,
        isDisabled: data?.hideImage,
      },
      horizontalAlign: {
        title: intl.formatMessage(teaserMessages.horizontalAlign),
        type: 'string',
        widget: 'position_widget',
      },
      verticalAlign: {
        title: intl.formatMessage(teaserMessages.verticalAlign),
        type: 'string',
        widget: 'position_widget',
        direction: 'vertical',
      },
      hideImage: {
        title: intl.formatMessage(messages.hideImage),
        type: 'boolean',
        default: false,
        isDisabled: data?.imageBackground,
      },
      hideSubtitle: {
        title: intl.formatMessage(messages.hideSubtitleCategory),
        type: 'boolean',
        default: false,
      },
      hideDescription: {
        title: intl.formatMessage(messages.hideDescription),
        type: 'boolean',
        default: false,
      },
    },
    required: ['href'],
  };

  // Extender: image_alt obrigatório se houver imagem e overwrite
  if (
    data?.overwrite &&
    (data?.href?.[0]?.image_field ||
      data?.href?.[0]?.hasPreviewImage ||
      data?.preview_image)
  ) {
    if (!schema.required.includes('image_alt')) {
      schema.required.push('image_alt');
    }
  }

  return schema;
};

export const gridTeaserDisableStylingSchema = ({ schema, formData, intl }) => {
  schema.fieldsets = schema.fieldsets.filter((item) => item.id !== 'styling');
  return schema;
};
